import './App.css';
import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Route-level code splitting with React.lazy
const HomePage = React.lazy(() => import('./HomePage'));
const VersionBPage = React.lazy(() => import('./version-b/VersionBPage'));
const FinalPage = React.lazy(() => import('./final/FinalPage'));
const FinalOnePage = React.lazy(() => import('./finalone/FinalOnePage'));
const MadrihPage = React.lazy(() => import('./madrih/MadrihPage'));
const ThankYou = React.lazy(() => import('./version-b/screens/ThankYou'));

// Minimal dark screen while lazy chunk loads (FirstScreen has its own loader)
const PageLoader = () => (
  <div style={{ minHeight: '100vh', background: '#1C1C1C' }} />
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<FinalOnePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/version-b" element={<VersionBPage />} />
          <Route path="/final" element={<FinalPage />} />
          <Route path="/finalone" element={<FinalOnePage />} />
          <Route path="/madrih" element={<MadrihPage />} />
          <Route path="/thanks" element={<ThankYou />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
